<template>
    <transition-group :tag="tag" name="v-fade-list">
        <slot />
    </transition-group>
</template>

<script>
    export default {
        name: 'FadeList',

        props: {
            tag: { type: String, default: 'div' },
        },
    }
</script>

<style>
.v-fade-list-enter-active, .v-fade-list-leave-active {
    transition: opacity .3s;
}

.v-fade-list-enter, .v-fade-list-leave-to {
    opacity: 0;
}
</style>
